import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMSRXEmployee } from "src/models/Stores/Employee.models";

interface MSRXEmployeeState {
  msrXEmployees: IMSRXEmployee[];
  msrXEmployeeToEdit: IMSRXEmployee | null;
}

const initialState: MSRXEmployeeState = {
  msrXEmployees: [],
  msrXEmployeeToEdit: null,
};

const msrXEmployeeSlice = createSlice({
  name: "MSRXEmployee",
  initialState,
  reducers: {
    setMSRXEmployeeList: (state, action: PayloadAction<IMSRXEmployee[]>) => {
      state.msrXEmployees = action.payload;
    },
    concatListMSRXEmployee: (
      state: MSRXEmployeeState,
      action: PayloadAction<IMSRXEmployee[]>
    ) => {
      state.msrXEmployees = [...state.msrXEmployees.concat(action.payload)];
    },
    setMSRXEmployeeToEdit: (
      state,
      action: PayloadAction<IMSRXEmployee | null>
    ) => {
      state.msrXEmployeeToEdit = action.payload;
    },
    addMSRXEmployee: (state, action: PayloadAction<IMSRXEmployee>) => {
      state.msrXEmployees.push(action.payload);
    },
    updateMSRXEmployee: (state, action: PayloadAction<IMSRXEmployee>) => {
      let itemIndex = state.msrXEmployees.findIndex(
        item => item.msrXEmployeeId === action.payload.msrXEmployeeId
      );
      if (itemIndex !== -1) state.msrXEmployees[itemIndex] = action.payload;
    },
    deleteMSRXEmployee: (state, action: PayloadAction<number>) => {
      const newArray = state.msrXEmployees.filter(
        item => item.msrXEmployeeId !== action.payload
      );
      state.msrXEmployees = newArray;
    },
  },
});

export const {
  setMSRXEmployeeList,
  concatListMSRXEmployee,
  setMSRXEmployeeToEdit,
  addMSRXEmployee,
  updateMSRXEmployee,
  deleteMSRXEmployee,
} = msrXEmployeeSlice.actions;

export default msrXEmployeeSlice.reducer;
